import type { SharePointFileLink, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

/**
 * @deprecated PERFORMANCE This should be replaced by a `getSharePointFileLinkField` selector.
 */
export const findById = createFindById('sharePointFileLinks');
/**
 * @deprecated PERFORMANCE This should be replaced by a `getSharePointFileLinkFieldThrows` selector.
 */
export const findByIdThrows = createFindByIdThrows('sharePointFileLinks');

type GetFulfilledSharePointFileLinks = (state: YammerState) => Record<string, SharePointFileLink>;
/**
 * @deprecated PERFORMANCE This returns an object containing ALL fullfilled SharePoint file links in the entire
 * store and will force re-renders when ANY of these entities change. This should be deleted.
 */
export const getFulfilledSharePointFileLinks: GetFulfilledSharePointFileLinks = (state) =>
  state.sharePointFileLinks.fulfilled.byId;
